import { makeAuthUseCases, makePasswordResetUseCases } from "@app/auth";
import { API } from "@infra/api";
import { browserTokenStore } from "@infra/storage/browserTokenStore";
import { browserImpersonationStore } from "@infra/storage/impersonationStore";

/**
 * Browser composition of the auth use cases. Constructed once at app startup
 * and provided to the React tree via `UseCasesProvider`. A CLI build would
 * have its own composition module that builds the same use cases with
 * Node-friendly adapters.
 *
 * `API.Users` (the legacy `UsersAPI` class) implements the `IUsers` port
 * directly — no adapter shim needed.
 *
 * Sub-namespaces:
 *  - `auth` for the active-session flows (login/register/logout/changePassword).
 *  - `passwordReset` for the forgot-password flow.
 *
 * Consumers reach them through `useAuthUseCases()` and destructure.
 */
export const authUseCases = {
	auth: makeAuthUseCases({
		userApi: API.Users,
		tokenStore: browserTokenStore,
		impersonationStore: browserImpersonationStore,
	}),
	passwordReset: makePasswordResetUseCases({
		userApi: API.Users,
	}),
};

export type AuthUseCases = typeof authUseCases;
